module.exports = __webpack_public_path__ + "static/media/blog3.6a6ba4b2.jpg";